import { render, staticRenderFns } from "./ContactReportsView.vue?vue&type=template&id=663e227f&scoped=true&"
import script from "./ContactReportsView.vue?vue&type=script&lang=ts&"
export * from "./ContactReportsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663e227f",
  null
  
)

export default component.exports